import {
  LuSearch,
  LuChevronDown,
  BsThreeDots,
} from "@/Components/Icons/Icons";

export default {
  row1 : [
  {
    column: "column1",

    rows: {
      row1: [
        {
          name: "Branch",
          label: "Branch Name",
          component: "text-field",
          width: "80%",
        },
        {
          name: "set",
          checkboxLabel: "Set as default",
          component: "checkboxbox",
          sx: {
            height: 65,
            alignItems: "end",
          },
        },
      ],
      row2: [
        {
          name: "Address",
          label: "Address",
          component: "text-field",
          width: "80%",
          sx: {
            borderRadius: 10,
          },
        },
        {
          name: "deactivate",
          checkboxLabel: "Deactivate",
          component: "checkboxbox",
          sx: {
            height: 65,
            alignItems: "end",
          },
        },
      ],
      row3: [
        {
          name: "Address",
          component: "text-field",
          width: "80%",
          gap: 5,
        },
      ],

      row4: [
        {
          name: "Address",
          component: "text-field",
          width: "80%",
          gap: 5,
        },
      ],
      row5: [
        {
          name: "country",
          label: "Country",
          component: "text-field",
          icon: LuSearch,
          iconColor: "gray-400",
          width: "80%",
        },
      ],
      row6: [
        {
          name: "State",
          label: "State/Province",
          component: "text-field",
          icon: LuSearch,
          iconColor: "gray-400",
          width: "80%",
        },
      ],
      row7: [
        {
          name: "city",
          label: "City",
          component: "text-field",
          icon: LuSearch,

        },
        {
          name: "postal",
          label: "Postal Code",
          component: "text-field",
        },
      ],
      row8: [
        {
          name: "tele",
          label: "Telephone",
          component: "text-field",
        },
        {
          name: "fax",
          label: "Fax",
          component: "text-field",
        },
      ],
      row9: [
        {
          name: "web",
          label: "Website",
          component: "text-field",
        },
        {
          name: "email",
          label: "Email",
          component: "text-field",
        },
      ],
      row10: [
        {
          name: "sales",
          label: "Sales Person",
          component: "dropdown",
          endIconName: "LuChevronDown",
          iconColor: "gray-400",
          width:"50%"
        },
        {
          name: "LOB wise",
          checkboxLabel: "LOB wise",
          component: "checkboxbox",
          sx: {
            height: 65,
            alignItems: "end",
          },
        },
        {
          name: "specialpermisson",
          component: "outlinebutton",
          sx: {
            mt: "33px",
          },
          width: "10%",
          iconName: BsThreeDots,
          iconSpacing: 0,
          iconPosition: "center",
        },
      ],
      row11: [
        {
          name: "Collection Exec",
          label: "Collection Exec",
          component: "dropdown",
          endIconName: "LuChevronDown",
           width:"50%"
        },
      ],
      row12: [
        {
          name: "Taxable Type",
          label: "Taxable Type",
          component: "dropdown",
          endIconName: "LuChevronDown",
          placeholder:"Standard",
           width:"50%"
        },
      ],
    },
  },
]
};
